import { createSlice } from '@reduxjs/toolkit';

const fullPaymentSlice = createSlice({
  name: 'fullPayment',
  initialState: {
    downPaymentSuccess: false,
    paystackOrderReference: null,
    error: null,
    downPaymentAmount: null,
    downPaymentAmountBeforePayment: null,
  },
  reducers: {
    setDownPaymentSuccess: (state, action) => {
      state.downPaymentSuccess = action.payload;
    },
    setPaystackOrderReference: (state, action) => {
      state.paystackOrderReference = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setDownPaymentAmount: (state, action) => {
      state.downPaymentAmount = action.payload;
    },
    setDownPaymentAmountBeforePayment: (state, action) => {
      state.downPaymentAmountBeforePayment = action.payload;
    },
    resetFullPayment: (state) => {
      state.downPaymentSuccess = false;
      state.paystackOrderReference = null;
      state.downPaymentAmount = null;
      state.downPaymentAmountBeforePayment = null;
    },
  },
});

export const {
  setDownPaymentSuccess,
  setPaystackOrderReference,
  setError,
  resetFullPayment,
  setDownPaymentAmount,
  setDownPaymentAmountBeforePayment,
} = fullPaymentSlice.actions;
export default fullPaymentSlice.reducer;
